import { OASLandingSearch } from '../features/landing/landing-search';

export default OASLandingSearch;
